// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD08_KH1R2XeP-wMW4zCmYP12-lkGrWDOY',
  authDomain: 'worldle-b4457.firebaseapp.com',
  projectId: 'worldle-b4457',
  storageBucket: 'worldle-b4457.firebasestorage.app',
  messagingSenderId: '369743457575',
  appId: '1:369743457575:web:6d9de9ea8a63274c664d02',
  measurementId: 'G-ZW0PK09RCR',
};

//   // Initialize Firebase
//   const app = initializeApp(firebaseConfig);
//   const analytics = getAnalytics(app);

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
